import type React from "react";
import { GooglePlacesAutocomplete } from "./GooglePlacesAutoComplete";
import type { PlacesApiStatus } from "./GooglePlacesAutoComplete";
import { useGooglePlaces } from "../../hooks/useGooglePlaces";

interface Country {
  _id: string;
  name: string;
  code: string;
}

interface AddressFormData {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  /** Map location of the picked place — null when Places had no geometry. */
  latitude: number | null;
  longitude: number | null;
}

interface AddressAutocompleteFieldProps {
  apiKey: string;
  value: string;
  onChange: (value: string) => void;
  onAddressSelect: (address: AddressFormData) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  countries?: Country[];
  size?: "sm" | "md";
  onBlur?: () => void;
  onStatusChange?: (status: PlacesApiStatus) => void;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  onPlaceSelectError?: () => void;
}

export const AddressAutocompleteField: React.FC<
  AddressAutocompleteFieldProps
> = ({
  apiKey,
  value,
  onChange,
  onAddressSelect,
  placeholder = "Enter address",
  disabled = false,
  error = false,
  countries = [],
  size = "md",
  onBlur,
  onStatusChange,
  inputRef,
  onPlaceSelectError,
}) => {
  const { convertPlaceToFormData } = useGooglePlaces(countries);

  const handlePlaceSelect = (placeDetails: any) => {
    const formData = convertPlaceToFormData(placeDetails);
    onAddressSelect(formData);
  };

  return (
    <GooglePlacesAutocomplete
      apiKey={apiKey}
      value={value}
      onChange={onChange}
      onPlaceSelect={handlePlaceSelect}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      size={size}
      onBlur={onBlur}
      onStatusChange={onStatusChange}
      inputRef={inputRef}
      onPlaceSelectError={onPlaceSelectError}
    />
  );
};
